import { render, staticRenderFns } from "./StaffGroupsModal.vue?vue&type=template&id=0a80a2c8&"
import script from "./StaffGroupsModal.vue?vue&type=script&lang=js&"
export * from "./StaffGroupsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports